import React from 'react';
import propTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import { Control, Field, Help, Checkbox } from 'src/ui/mui-ui-kit';

const HelperWrapper = posed.div({
  enter: {
    opacity: 1,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -10,
  },
});

export function UiCheckbox({ label, hideHelp, errorMessage, ...rest }) {
  const hasError = errorMessage ? 'danger' : '';

  return (
    <Field>
      <Control>
        <Checkbox {...rest}> {label}</Checkbox>
      </Control>
      <div className="helper-wrapper">
        <PoseGroup>
          {!hideHelp && errorMessage && (
            <HelperWrapper key="helper">
              <Help hasTextColor={hasError}>{errorMessage}</Help>
            </HelperWrapper>
          )}
        </PoseGroup>
      </div>
    </Field>
  );
}

UiCheckbox.defaultProps = {
  hideHelp: false,
  errorMessage: '',
};

UiCheckbox.propTypes = {
  label: propTypes.string.isRequired,
  hideHelp: propTypes.bool,
  errorMessage: propTypes.string,
};
